import { Request } from '../../../httpClient/serverApi/requests/Request';
import { ISchedule } from '../../../schedule/types/ISchedule';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { ISiteNameWithId } from '../../../ts/ServerApi/types/ISiteNameWithId';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { ISubscription } from '../types/ISubscription';

export interface IGetSubscriptionsResult extends IGetItemsResult {
  subscriptions: ISubscription[];
  schedules: ISchedule[];
  sites: ISiteNameWithId[];
  users: IUser[];
}

export class GetSubscriptionsRequest extends Request<IGetItemsParams, IGetSubscriptionsResult> {
  constructor(params: IGetItemsParams) {
    super('getSubscriptions', params);
  }
}
